import { render, staticRenderFns } from "./GroupByDimension.vue?vue&type=template&id=e352bf3e"
import script from "./GroupByDimension.vue?vue&type=script&lang=ts"
export * from "./GroupByDimension.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports